// extracted by mini-css-extract-plugin
export default {"tier4BadgeOptionTooltip":"Tier4BadgeOptionTooltip_tier4BadgeOptionTooltip__QTuoh"};